import { CommonNodeViewWrapper } from '@/components/common/node-view-wrapper';
import type { ReactNodeViewProps } from '@tiptap/react';
import { NodeViewContent } from '@tiptap/react';

export function ZyInlineEnumNodeView({ selected, decorations }: ReactNodeViewProps) {
    return (
        <CommonNodeViewWrapper
            decorations={decorations}
            label="zyInlineEnum"
            selected={selected}
        >
            <NodeViewContent />
        </CommonNodeViewWrapper>
    );
}
